<template>
    <label class="custom-switch">
        <input type="checkbox" :id="name" v-model="localValue" :disabled="disabled">
        <span class="custom-slider round"></span>
    </label>
</template>

<script>
export default {
    name: 'CustomCheckbox',
    props: ['name', 'is_checked', 'disabled'],
    methods: {

    },
    computed: {
        localValue: {
            get: function () {
                return this.is_checked
            },
            set: function (value) {
                this.$emit('check_changed', {
                    name: this.name,
                    value: value
                })
            }
        }
    }
}
</script>

<style>
.custom-switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 14px;
    margin: 7px;
}

.custom-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.custom-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.custom-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: -1px;
    bottom: -3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border: 1px solid lightgray;
}

input:checked+.custom-slider {
    background-color: var(--light-primary-color);
}

input:focus+.custom-slider {
    box-shadow: 0 0 1px #ccc;
}

input:checked+.custom-slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
    background-color: var(--primary-color);
    border: none;
}

/* Rounded sliders */
.custom-slider.round {
    border-radius: 34px;
}

.custom-slider.round:before {
    border-radius: 50%;
}
</style>
